import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setPosts } from '../redux/appSlice';
import PostCard from './PostCard';

const PostsWidget = ({userId,isProfile=false}) => {
  const {posts}=useSelector((state)=>state.app)
  const {token}=useSelector((state)=>state.app)
  const dispatch=useDispatch()

  const getPosts=async()=>{
    const response= await fetch(`https://thoughtful-erin-oyster.cyclic.app/posts`,{
      method:"GET",
      headers:{
        authorization:`Bearer ${token}`
      }
    })
    const data=await response.json()
    dispatch(setPosts({posts:data}))
  }

  const getUserPost=async()=>{
    const response= await fetch(`https://thoughtful-erin-oyster.cyclic.app/posts/${userId}/posts`,{
      method:"GET",
      headers:{
        authorization:`Bearer ${token}`
      }
    })
    const data= await response.json()
    dispatch(setPosts({posts:data}))
  }


  useEffect(()=>{
    if(isProfile){
      getUserPost()
    }
    else{
      getPosts()
    }
  },[isProfile,userId])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='xs:min-w-[240px] xs:max-w-[500px] flex flex-col gap-2'>
      {posts?.map(({_id,userId,firstName,lastName,description,location,picturePath,userPicturePath,likes,comments})=>(
        <PostCard
        key={_id}
        postId={_id}
        postUserId={userId}
        name={`${firstName} ${lastName}`}
        description={description}
        location={location}
        picturePath={picturePath}
        userPicturePath={userPicturePath}
        likes={likes}
        comments={comments} 
        />
      ))}
    </div>
  )
}

export default PostsWidget